import React, { useEffect } from "react";
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useToast,
} from "@chakra-ui/react";
import useAxios from "axios-hooks";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import isEmpty from "lodash/isEmpty";

import { PortSMTP, PortSMTPOption, ROOT_API, API_ROUTES } from "utils/constant";
import InputController from "components/Form/InputController";
import SelectController from "components/Form/SelectController";

const defaultValues = {
  brand: "",
  port: PortSMTP.FES,
  authUserEmail: "",
  authUserPassword: "",
  host: "",
};

const AddBackupEmail = ({
  isOpen,
  onOpen,
  onClose,
  fetchData,
  smtpSetting,
  smtpId,
}) => {
  const cancelRef = React.useRef();
  const toast = useToast();

  const [{ loading: createLoading }, createSMTPServerApi] = useAxios(
    {
      url: ROOT_API + API_ROUTES.SMTP_SERVER_BACKUP_EMAIL,
      method: "post",
    },
    { manual: true }
  );
  const [{ loading: updateLoading }, updateSMTPServerApi] = useAxios(
    {
      url: ROOT_API + API_ROUTES.SMTP_SERVER_UPDATE_BACKUP_EMAIL,
      method: "post",
    },
    { manual: true }
  );

  const schema = yup.object().shape({
    authUserEmail: yup.string().required("Vui lòng nhập email"),
    // .test('isValidEmail', 'Email không hợp lệ', value => {
    //   return schemaTest.isValidEmail(value);
    // }),
    authUserPassword: yup
      .string()
      .nullable()
      .required("Vui lòng nhập mật khẩu"),
    // .test('isValidPassword', 'Mật khẩu không hợp lệ', value => {
    //   return schemaTest.isValidPassword(value);
    // }),
  });
  const { control, setValue, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  useEffect(() => () => reset(), []);

  useEffect(() => {
    if (!isEmpty(smtpSetting)) {
      reset({
        id: smtpSetting?._id,
        host: smtpSetting?.host,
        port: PortSMTPOption.find((item) => +item.value === +smtpSetting?.port),
        authUserEmail: smtpSetting?.authUserEmail,
        authUserPassword: smtpSetting?.authUserPassword,
      });
    }
  }, [smtpSetting]);

  const handleSuccess = () => {
    toast({
      title: "Thêm email backup thành công",
      status: "success",
      duration: 9000,
      isClosable: true,
    });
    fetchData?.();
    onClose?.();
  };

  const handleError = (error) => {
    toast({
      title:
        error?.response?.data?.errors?.[0]?.msg ||
        error?.response?.data?.msg ||
        "Thêm email backup không thành công",
      status: "error",
      duration: 9000,
      isClosable: true,
    });
  };

  const onSubmit = (values) => {
    toast.closeAll();

    if (!isEmpty(smtpSetting)) {
      updateSMTPServerApi({
        data: {
          ...values,
          id: smtpId,
          port: values?.port.value,
          backupId: smtpSetting._id,
        },
      })
        .then((res) => {
          handleSuccess();
        })
        .catch((error) => {
          handleError(error);
        });

      return;
    }

    createSMTPServerApi({
      data: { ...values, id: smtpId, port: values?.port.value },
    })
      .then((res) => {
        handleSuccess();
      })
      .catch((error) => {
        handleError(error);
      });
  };

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={() => {
        onClose?.();
      }}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>Email Backup</AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody>
          <form>
            <InputController
              control={control}
              name="host"
              label="Host"
              styleContainer={{ pt: "4" }}
            />
            <SelectController
              styleContainer={{ pt: "4" }}
              control={control}
              defaultValues={PortSMTP.FES}
              options={PortSMTPOption}
              isRequired
              name="port"
              label="Port"
            />
            <InputController
              styleContainer={{ pt: "4" }}
              control={control}
              name="authUserEmail"
              label="User Email"
              isRequired
            />
            <InputController
              styleContainer={{ pt: "4" }}
              control={control}
              name="authUserPassword"
              label="User Password"
              isRequired
            />
          </form>
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button
            ref={cancelRef}
            onClick={() => {
              onClose?.();
            }}
          >
            Hủy
          </Button>
          <Button
            colorScheme="red"
            ml={3}
            isLoading={createLoading || updateLoading}
            onClick={handleSubmit(onSubmit)}
          >
            {isEmpty(smtpSetting) ? "Lưu" : "Cập nhật"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AddBackupEmail;
